import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'

export const GALLERY_PAGE_SIZE = 24
export const GALLERY_PAGE_SIZE_WITH_PAGINATION = 48
export const GALLERY_LOAD_MORE_THRESHOLD = 8
export const GALLERY_LOAD_MORE_PAGES = 3
export const COOKIE_MAX_CHARACTERS = 4096
export const MULTI_SELECTABLE_FACET_CATEGORY = 'price'
export const DESKTOP_MODAL_FILTERS_MENU_WIDTH = '350px'
export const FILTERS_MENU_OFFSET = 56
export const FILTERS_MENU_RESULTS_CTA_CONTAINER_HEIGHT = 85

export const PARENT_DEPARTMENTS = [
  'ALL_CARDS' as DepartmentsEnum,
  'ALL_GIFTS' as DepartmentsEnum,
  'ALL_FLOWERS_AND_PLANTS' as DepartmentsEnum,
]

export const SEARCH_TITLE_FOR_TRACKING = 'Search Results'

export const SEARCH_PAGE_TYPE = 'Search'
export const GALLERY_PAGE_TYPE = 'Gallery'
export const DYNAMIC_PAGE_TYPE = 'Dynamic'
export const COLLECTION_PAGE_TYPE = 'Collection'
export const PAY_PER_CLICK_PAGE_TYPE = 'PayPerClick'
export const GALLERY_RESULTS_TYPE = 'gallery results'
export const SEARCH_RESULTS_TYPE = 'search results'
export const DYNAMIC_RESULTS_TYPE = 'dynamic results'

export const notRudeFilter = {
  facetKey: 'not-rude',
  group: 'not rude',
  userApplied: true,
}

export const MULTI_BUY_COOKIE_NAME = 'mnpg_multi_buy_enabled'
